import prepaymentAddendumRenameTool from "./prepaymentAddendumRenameTool";

const tools = {
  prepaymentAddendumRenameTool,
};

export default tools;
